import classNames from 'classnames'
import { Link } from 'gatsby'
import React, { useContext } from 'react'

import { useSelectedCurrency } from '../hooks/useSelectedCurrency'
import {
  formatPriceRange,
  isHyphenatedLocale,
  LocaleContext,
} from '../locale/i18n'
import { staticPagePaths } from '../locale/pathing'
import { Product } from '../logic/catalog'
import { renderFormulas } from '../logic/formatting'
import { gaEvents } from '../logic/ga4'
import { getPriceRange } from '../logic/price'
import { StaticPage } from '../logic/staticPage'

import './MiniProductPreview.scss'
import { buttonClasses } from './Button'

const MiniProductPreview = (product: Product) => {
  const { name, slug, webshopEnabled } = product
  const { locale, t } = useContext(LocaleContext)
  const { currency } = useSelectedCurrency()
  const priceRange = getPriceRange(product, currency)

  return (
    <Link
      className="miniProductPreview"
      onClick={() => {
        gaEvents.productClicked(product)
      }}
      to={[staticPagePaths[StaticPage.PRODUCTS][locale], slug, '/'].join('')}
    >
      <h3
        className={classNames('miniProductPreview__title', {
          hyphenate: isHyphenatedLocale(),
        })}
      >
        {name ? renderFormulas(name) : null}
      </h3>
      <div className="miniProductPreview__footer">
        <div className="miniProductPreview__price">
          {priceRange && formatPriceRange(priceRange, locale, currency)}
        </div>
        <div className={buttonClasses()}>
          {webshopEnabled
            ? t('productListing.buyOnline')
            : t('productListing.readMore')}
        </div>
      </div>
    </Link>
  )
}

export default MiniProductPreview
